import { DELETE_DMX_DEVICE, DELETE_DMX_DEVICE_SUCCESSFUL, DELETE_DMX_DEVICE_FAILED } from './actionTypes';

export const deleteDmxDevice = (device) => {
  return {
    type: DELETE_DMX_DEVICE,
    payload: { device },
  };
};

export const deleteDmxDeviceSuccessful = (message) => {
  return {
    type: DELETE_DMX_DEVICE_SUCCESSFUL,
    payload: message,
  };
};

export const deleteDmxDeviceFailed = (message) => {
  return {
    type: DELETE_DMX_DEVICE_FAILED,
    payload: message,
  };
};
